<app-splash-screen></app-splash-screen>
<router-outlet></router-outlet>